import * as React from "react";
import {Fragment} from "react";
import QuoteCommentNotification from "../../../model/notification/quote/QuoteCommentNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: QuoteCommentNotification
}

/**
 * Quote comment notification toast body.
 */
const NotificationQuoteCommentBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Lead {props.notification.data.leadReferenceNumber}</div>
			<div className={"toast-body"}>
				<strong>New quote comment</strong>
			</div>
		</Fragment>
	);
};

export default NotificationQuoteCommentBody;
